<div class="stepper" [ngClass]="{'alternate-stepper': alternatePlacement}">
  <ng-container *ngIf="contents.length">
    <div class="step-content-container" [ngClass]="{'alternate-step-content-container': alternatePlacement}"
      *ngFor="let content of contents;let i=index;let last=last" [id]="content._id">
      <div class="step">
        <div class="circle"></div>
        <div class="line"></div>
        <div *ngIf="last && showMoreCircle()" class="line" [ngClass]="showMore ? 'gradient-true' : 'gradient-false'">
        </div>
        <div class="circle" *ngIf="last && !showMoreCircle()"></div>
        <div class="showMore" *ngIf="last && showMoreCircle()" [matBadge]="hiddenItemCount"
          matBadgePosition="above after" [matTooltip]="showMore ? 'Show ' + hiddenItemCount + ' more' : 'Hide'"
          [ngStyle]="{ 'background-color': showMore ? '#13a10e' : '#d13438' }" (click)="onShowMore()">{{
          showMore ? '+' : '--' }}</div>
      </div>
      <div class="content-container" [ngClass]="{'alternate-content': alternatePlacement}">
        <div class="content-title">
          <div class="avatar-name-container">
            <ngx-avatars [name]="content.title" size="30"></ngx-avatars>
            <mat-label style="font-weight: 500;"> {{ content.title }} | {{content.modifiedTime | date : 'MMM
              dd, yyyy , hh:mm a'}}</mat-label>
            <span *ngIf="content.isEmailReply" class="material-icons email-reply-icon">mail_outline</span>
          </div>
        </div>
        <div class="content">
          <div *ngIf="content.changes && content.changes.length">
            <ul class="mb-0 list">
              <li class="content" *ngFor="let data of content.changes" [innerHTML]="data"></li>
            </ul>
          </div>
          <div class="content-description">
            <div *ngIf="content.description" style="display:flex;gap:0.5rem">
              <div class="comment">Comment:</div>
              <div class="description" [innerHTML]="content.description"></div>
            </div>
            <div *ngIf="content.attachments.length">
              <div class="other_file_container">
                <ng-container *ngFor="let item of content.attachments; let i = index;">
                  <mat-card *ngIf="!isSupportedImage(item);" class="timeline-content-file-card">
                    <div class="file-icon">
                      <mat-icon>insert_drive_file</mat-icon>
                    </div>
                    <div class="file-details">
                      <div class="file-name" [matTooltip]="getFileName(item)"
                        matTooltipClass="timeline-content-file-name-custom-tooltip">{{getFileName(item)}}</div>
                    </div>
                    <div class="file-actions">
                      <button mat-icon-button matTooltip="download" (click)="downloadFile(item)">
                        <mat-icon style="color: '#424141';">download</mat-icon>
                      </button>
                    </div>
                  </mat-card>
                </ng-container>
              </div>
              <ng-container *ngFor="let item of content.attachments; let i = index;">
                <a>
                  <img *ngIf="isSupportedImage(item);" class="image-container" [src]="item.src"
                    alt="collaboration-image" (click)="open(content.attachments, i)" oncontextmenu="return false;">
                </a>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="empty-state-container" *ngIf="!contents.length">{{emptyStateText}}</div>
</div>